import { useCallback } from 'react';

import {
  getCreatedResourceMessage,
  type Resource,
  RESOURCE_CONTENT_TYPE,
  validateResourceFileType,
} from 'src/data/performance';
import type { Callback } from 'src/lib/types';
// @ts-expect-error - useNotificationActions does not have types
import { useNotificationActions } from 'src/store/notification';
// @ts-expect-error - useResourcePopup does not have types
import { useResourcePopup } from 'src/views/ResourcePopup';

export const useHandlers = ({
  eventPage,
  allowedFileTypes,
  onSelect,
}: {
  eventPage?: string;
  allowedFileTypes?: string[];
  onSelect: Callback<Resource | undefined>;
}) => {
  const openAddResourcePopup = useResourcePopup({ page: eventPage });

  const notifications = useNotificationActions();

  const handleSelect = useCallback(
    (selected?: { resource?: Resource; url?: string }) => {
      if (selected?.resource) {
        onSelect(selected?.resource);
      } else if (selected?.url) {
        const transientResource = {
          contentType: RESOURCE_CONTENT_TYPE.url,
          content: selected?.url,
        };
        onSelect(transientResource);
      } else {
        onSelect(undefined);
      }
    },
    [onSelect]
  );

  const handleAddResource = useCallback(async () => {
    const createdResource = await openAddResourcePopup({ forceDocumentOnly: true });
    if (!createdResource) {
      return;
    }

    if (
      Array.isArray(allowedFileTypes) &&
      !validateResourceFileType(createdResource, allowedFileTypes)
    ) {
      return;
    }

    onSelect(createdResource);
    const message = getCreatedResourceMessage(createdResource);
    notifications.displaySuccess(message, null, { timeout: 5000 });
  }, [openAddResourcePopup, allowedFileTypes, onSelect, notifications]);

  return {
    handleSelect,
    handleAddResource,
  };
};
